import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  padding: 1em 0.25em;
`;
const ItemGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding: 0;
  transition: all ease-out 0.25s;
  column-gap: 40px;
  row-gap: 40px;
  border-radius: 4px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const Colors = styled.div`
  position: absolute;
  bottom: 0;
  left: 1em;
  right: 1em;
  display: grid;
  align-items: center;
  padding: 10px 0;
  justify-items: center;
  grid-template-columns: repeat(auto-fit, minmax(24px, 24px));
  column-gap: 8px;
  row-gap: 8px;
  opacity: 0;
  background: #fff;
  transition: all ease-out 0.25s;
  min-height: 16%;
  justify-content: center;
  > div {
    width: 100%;
    height: 24px;
  }
`;
const Item = styled.div`
  border-radius: 2px;
  transform: scale(1);
  padding: 1em;
  position: relative;
  background: #fff;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
  transition: all ease-out 0.25s;
  cursor: pointer;
  &:hover {
    ${Colors} {
      opacity: 1;
    }
  }
`;

const ProductLink = styled.div``;
const ProductImage = styled.div`
  color: transparent;
  display: inline-block;
  width: 100%;
  margin: 1em 0;
`;
const Img = styled.img`
  width: 100%;
  height: 200px;
  object-fit: contain;
  margin: 0.5em auto;
  padding-bottom: 0.5em;
  border-bottom: 1px solid #ccc;
`;
const Description = styled.div`
  min-height: 45px;
`;
const Text = styled.p`
  text-align: center;
  margin: 0;
  color: #283948;
  font-weight: 600;
  font-size: 1.15 em;
`;
const Amount = styled.p`
  color: ${COLORS.GREY};
  text-align: center;
  margin: 0;
  font-weight: 600;
  font-size: 1.25em;
`;

const Category = styled.div`
  position: absolute;
  top: 3px;
  right: 4px;
`;

const Popular = styled.span`
  background: ${COLORS.RED};
  margin-left: 5px;
  color: ${COLORS.WHITE};
  font-size: 12px;
  min-width: 10px;
  padding: 3px 7px;
  border-radius: 10px;
`;
const New = styled.span`
  background: ${COLORS.BLACK};
  margin-left: 5px;
  color: ${COLORS.WHITE};
  font-size: 12px;
  min-width: 10px;
  padding: 3px 7px;
  border-radius: 10px;
`;

const NoProdcuts = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 50px 0;
  text-align: center;
  svg {
    font-size: 50px;
  }
`;

const DialogTitle = styled.div`
  font-weight: 100;
  font-size: 24px;
  margin-bottom: 20px;
  color: ${COLORS.BODY_TEXT};
  border-bottom: 2px solid #666;
  padding-bottom: 10px;
`;

const AdminItemGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding: 0;
  transition: all ease-out 0.25s;
  column-gap: 40px;
  row-gap: 40px;
  border-radius: 4px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

const SearchWrapper = styled.div`
  margin: 20px 0;
`;

export {
  Container,
  ItemGroup,
  Item,
  ProductLink,
  ProductImage,
  Img,
  Description,
  Text,
  Amount,
  Colors,
  Category,
  Popular,
  New,
  NoProdcuts,
  DialogTitle,
  AdminItemGroup,
  SearchWrapper,
};
